export enum ReportType {
  SETTINGS_INFORMATION_CARD = 'SETTINGS_INFORMATION_CARD',
  NONE = 'NONE',
  TIMESHEET = 'TIMESHEET',
  VIOLATIONS = 'VIOLATIONS',
  GROUPED_VIOLATIONS = 'GROUPED_VIOLATIONS',
  DRIVER_ACTIVITIES = 'DRIVER_ACTIVITIES',
  DRIVER_DAILY_ACTIVITIES = 'DRIVER_DAILY_ACTIVITIES',
  DRIVER_WEEKLY_ACTIVITIES = 'DRIVER_WEEKLY_ACTIVITIES',
  TIMESHEET_AMOUNTS_REPORT = 'TIMESHEET_AMOUNTS_REPORT',
  TRIP_SUMMARY = 'TRIP_SUMMARY',
  TRIP_DETAILS = 'TRIP_DETAILS',
  TRIP_GENERAL_STATEMENT = 'TRIP_GENERAL_STATEMENT',
  BASIC_TRIP_PRINT = 'BASIC_TRIP_PRINT',
  GROUPED_TRIP_BASICS = 'GROUPED_TRIP_BASICS',
  TIMESHEET_LUMPSUM_SETTLEMENT = 'TIMESHEET_LUMPSUM_SETTLEMENT',
  TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY = 'TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY',
  DRIVER_AVAILABLE_TIME = 'DRIVER_AVAILABLE_TIME',
  CARD_READING_DEADLINE = 'CARD_READING_DEADLINE',
  DRIVER_CARD_READING = 'DRIVER_CARD_READING',
  DRIVER_INSTRUCTION = 'DRIVER_INSTRUCTION',
  TIMESHEET_SUMMARY = 'TIMESHEET_SUMMARY',
  DOCUMENT_VALIDITY_DEADLINE = 'DOCUMENT_VALIDITY_DEADLINE',
  DRIVER_FAULTS_AND_EVENTS = 'DRIVER_FAULTS_AND_EVENTS',
  DRIVER_CARD_APPLICATION = 'DRIVER_CARD_APPLICATION',
  OUTGOING_CHECKLIST = 'OUTGOING_CHECKLIST',
  BUSINESS_TRIP_COMMAND = 'BUSINESS_TRIP_COMMAND',
  TRIP_DEPOSIT_REQUEST = 'TRIP_DEPOSIT_REQUEST',
  DRIVER_DATA_COMPLETNESS = 'DRIVER_DATA_COMPLETNESS',
  DRIVER_ATTESTATION_REPORT = 'DRIVER_ATTESTATION_REPORT',
  TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS = 'TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS',
  TIMESHEET_PERIOD_SUMMARY = 'TIMESHEET_PERIOD_SUMMARY',
  TIMESHEET_WORKING_HOURS = 'TIMESHEET_WORKING_HOURS',
  DRIVER_FREE_DAYS = 'DRIVER_FREE_DAYS',
  TIMESHEET_OVERHOURS_SUMMARY = 'TIMESHEET_OVERHOURS_SUMMARY',
  TIMESHEET_FOREIGN_AMOUNT_SUMMARY = 'TIMESHEET_FOREIGN_AMOUNT_SUMMARY',
  TIMESHEET_FOREIGN_AMOUNTS_REPORT = 'TIMESHEET_FOREIGN_AMOUNTS_REPORT',
  TIMESHEET_FOREIGN_AMOUNTS_FOR_DRIVER_REPORT = 'TIMESHEET_FOREIGN_AMOUNTS_FOR_DRIVER_REPORT',
  DRIVER_DAY_DETAILS = 'DRIVER_DAY_DETAILS',
  DRIVER_DAY_DETAILS_WITH_SIGNATURE_REPORT = 'DRIVER_DAY_DETAILS_WITH_SIGNATURE_REPORT',
  TRIP_FOREIGN_COUNTRY = 'TRIP_FOREIGN_COUNTRY',
  LOCALIZATION = 'LOCALIZATION',
  TIMESHEET_TIME_SUMMARY = 'TIMESHEET_TIME_SUMMARY',
  DRIVER_CALENDAR = 'DRIVER_CALENDAR',
  VEHICLE_CALENDAR = 'VEHICLE_CALENDAR',
  WEEKLY_RESTS = 'WEEKLY_RESTS',
  SPECIFIC_BUSINESS_TRIP_COMMAND = 'SPECIFIC_BUSINESS_TRIP_COMMAND',
  TRIP_INVOICES = 'TRIP_INVOICES',
  DRIVER_PERIOD_DISTANCE = 'DRIVER_PERIOD_DISTANCE',
  TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS = 'TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS',
  TIMESHEET_YEAR_SUMMARY = 'TIMESHEET_YEAR_SUMMARY',
  COMPANY_REPUTATION_INDEX = 'COMPANY_REPUTATION_INDEX',
  VEHICLE_ACTIVITIES = 'VEHICLE_ACTIVITIES',
  VEHICLE_DAILY_ACTIVITIES = 'VEHICLE_DAILY_ACTIVITIES',
  VEHICLE_WEEKLY_ACTIVITIES = 'VEHICLE_WEEKLY_ACTIVITIES',
  VEHICLE_DATA_COMPLETNESS = 'VEHICLE_DATA_COMPLETNESS',
  VEHICLE_CARD_READING_DEADLINE = 'VEHICLE_CARD_READING_DEADLINE',
  VEHICLE_CALIBRATION_DEADLINE = 'VEHICLE_CALIBRATION_DEADLINE',
  VEHICLE_CARD_READING_AND_CALIBRATION_DEADLINE = 'VEHICLE_CARD_READING_AND_CALIBRATION_DEADLINE',
  VEHICLE_DAY_DETAILS = 'VEHICLE_DAY_DETAILS',
  VEHICLE_FAULTS_AND_EVENTS = 'VEHICLE_FAULTS_AND_EVENTS',
  DRIVER_ACTIVITY_SUMMARY = 'DRIVER_ACTIVITY_SUMMARY',
  MANAGER_REPORT_1 = 'MANAGER_REPORT_1',
  MANAGER_REPORT_2 = 'MANAGER_REPORT_2',
  MANAGER_REPORT_3 = 'MANAGER_REPORT_3',
  TIMESHEET_DETAILED_WAGE_REPORT = 'TIMESHEET_DETAILED_WAGE_REPORT',
  DATA_ACCESS_EVENTS = 'DATA_ACCESS_EVENTS',
  DRIVERS_VIOLATIONS = 'DRIVERS_VIOLATIONS',
  FOREIGN_COUNTRY_SERVICE_DECLARATIONS_DEADLINES = 'FOREIGN_COUNTRY_SERVICE_DECLARATIONS_DEADLINES',
  FOREIGN_COUNTRY_DECLARATIONS_DEADLINES = 'FOREIGN_COUNTRY_DECLARATIONS_DEADLINES',
  ACTIVITY_CHANGE_CONFIRMATION_REPORT = 'ACTIVITY_CHANGE_CONFIRMATION_REPORT',
  VEHICLES_LIST = 'VEHICLES_LIST',
  DRIVERS_LIST = 'DRIVERS_LIST',
  DRIVER_APPLICATIONS = 'DRIVER_APPLICATIONS',
  ALL_ALERTS = 'ALL_ALERTS',
  SELECTED_ALERTS = 'SELECTED_ALERTS',
  MOBILITY_PACKAGE_PAYROL_REPORT = 'MOBILITY_PACKAGE_PAYROL_REPORT',
  REWARDS_TO_ACCEPT_REPORT = 'REWARDS_TO_ACCEPT_REPORT',
  TIMESHEET_SCHEDULE = 'TIMESHEET_SCHEDULE',
  FOREIGN_ALLOWANCES = 'FOREIGN_ALLOWANCES',
  TIMESHEET_PAYMENT_DETAILS = 'TIMESHEET_PAYMENT_DETAILS',
  // Same report as TIMESHEET_PAYMENT_DETAILS, but requested as a CSV export.
  TIMESHEET_PAYMENT_DETAILS_CSV = 'TIMESHEET_PAYMENT_DETAILS_CSV',
  TRIP_COSTS = 'TRIP_COSTS',
  STATEMENT_ON_EMPLOYEES_COUNT = 'STATEMENT_ON_EMPLOYEES_COUNT',
  DRIVER_YEAR_GROSS_AMOUNTS = 'DRIVER_YEAR_GROSS_AMOUNTS',
  DECLARATION_NOT_RETURN_TO_PLACE_OF_RESIDENCE = 'DECLARATION_NOT_RETURN_TO_PLACE_OF_RESIDENCE',
  TIMESHEET_LUMPSUM_UTILIZATION = 'TIMESHEET_LUMPSUM_UTILIZATION',
  WEEKLY_RESTS_WITH_LOCATION = 'WEEKLY_RESTS_WITH_LOCATION',
  VIRTUAL_DISPLACEMENT = 'VIRTUAL_DISPLACEMENT',
  TIMESHEET_LEAVES_CALCULATION = 'TIMESHEET_LEAVES_CALCULATION',
  SELECTED_TIMESHEET_MOBILITY_PACKAGE_PAYROLL_REPORT = 'SELECTED_TIMESHEET_MOBILITY_PACKAGE_PAYROLL_REPORT',
  SELECTED_REWARDS_TO_ACCEPT_REPORT = 'SELECTED_REWARDS_TO_ACCEPT_REPORT',
  TIMESHEET_CALCULATION_AUDIT = 'TIMESHEET_CALCULATION_AUDIT',
  DRIVER_CONTRACT_SUMMARY = 'DRIVER_CONTRACT_SUMMARY',
  DRIVER_CONTRACT_ANNEX = 'DRIVER_CONTRACT_ANNEX',
  /** Umowa albo aneks — jeden wydruk wg najnowszego wpisu w danych kierowcy. */
  DRIVER_CONTRACT_ADAPTIVE = 'DRIVER_CONTRACT_ADAPTIVE',
  /** Zbiorczy XLSX: praca nocna, dyżur 50%/100% (czas) i dni delegacji krajowych. */
  NIGHT_WORK_DUTY_DELEGATIONS_REPORT = 'NIGHT_WORK_DUTY_DELEGATIONS_REPORT',
  /** Podstawa ekwiwalentu za niewykorzystany urlop — odpowiednik wydruku z Optimy. */
  TIMESHEET_LEAVE_EQUIVALENT_CALCULATION = 'TIMESHEET_LEAVE_EQUIVALENT_CALCULATION',
  /** Zbiorczy XLSX: najnowsza karta kierowcy, data wydania i generacja (G2v2 zapisuje przekroczenia granic). */
  DRIVER_CARDS = 'DRIVER_CARDS',
  /** Zbiorczy PDF: wstawiony i proponowany urlop per miesiąc oraz saldo roku. */
  TIMESHEET_LEAVE_DAYS_REPORT = 'TIMESHEET_LEAVE_DAYS_REPORT',
  TIMESHEET_WORK_COSTS = 'TIMESHEET_WORK_COSTS',
  TIMESHEET_PAYMENT_REPORT = 'TIMESHEET_PAYMENT_REPORT',
  DRIVER_WORKING_DAYS = 'DRIVER_WORKING_DAYS',
  DRIVER_COMPLETE_SETTLEMENT = 'DRIVER_COMPLETE_SETTLEMENT',
  TIMESHEET_REWARD_FOR_DRIVERS = 'TIMESHEET_REWARD_FOR_DRIVERS',
  DRIVER_CARD_INSERTION_WITHDRAWAL = 'DRIVER_CARD_INSERTION_WITHDRAWAL',
  DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE = 'DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE',
  VEHICLE_CARD_INSERTION_WITHDRAWAL = 'VEHICLE_CARD_INSERTION_WITHDRAWAL',
  VEHICLE_TACHOGRAPH_DEADLINE = 'VEHICLE_TACHOGRAPH_DEADLINE',
  VEHICLE_TACHO_DETAILS = 'VEHICLE_TACHO_DETAILS',
  DRIVER_CONTRACTS_FROM_PERIOD = 'DRIVER_CONTRACTS_FROM_PERIOD',
  DRIVER_ACTIVENESS = 'DRIVER_ACTIVENESS',
  TIMESHEET_EMPTY_DAYS = 'TIMESHEET_EMPTY_DAYS',
  CARD_READING_DEADLINE_SERVICE = 'CARD_READING_DEADLINE_SERVICE',
  FREE_DAYS_SUMMARY_SERVICE = 'FREE_DAYS_SUMMARY_SERVICE',
  MINIMAL_PAYMENT_COUNTRY_HOURS_SERVICE = 'MINIMAL_PAYMENT_COUNTRY_HOURS_SERVICE',
  MINIMAL_PAYMENT_COUNTRY_AMOUNTS_SERVICE = 'MINIMAL_PAYMENT_COUNTRY_AMOUNTS_SERVICE',
  TIMESHEET_HOURS_SERVICE = 'TIMESHEET_HOURS_SERVICE',
  FOREIGN_TRIPS_SERVICE = 'FOREIGN_TRIPS_SERVICE',
  TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT = 'TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT',
}
